import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import { env } from '~/commons/config';

import PageArticles from './PageArticles.jsx';
import PageArticle from './PageArticle.jsx';
//閱讀材料
const root = document.getElementById('articles');

if (root) {
  ReactDOM.render(
    (
      <Router basename={env.base}>
        <Switch>
          <Route exact path="/articles">
            <PageArticles />
          </Route>
          <Route path="/articles/:_id">
            <PageArticle />
          </Route>
        </Switch>
      </Router>
    ),
    root,
  );
}
